import { PSEA_CORE_STANDARDS } from "./pseaCoreStandards";

export const formatBytes = (bytes: any) => {
  if (!bytes || bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

/**
 * Maps a saved PSEA assessment record's core standards into the shape used by
 * the form/modals, aligned to the canonical 8-standard order.
 */
export const hydrateCoreStandards = (record: any) => {
  const existing = record?.coreStandards || [];
  return PSEA_CORE_STANDARDS.map((standard) => {
    const match = existing.find(
      (cs: any) => Number(cs?.standardNumber) === standard.number
    );
    // A standard marked not applicable stores `meetsStandard: null`, so the
    // two fields are read back independently.
    const notApplicable =
      standard.allowNotApplicable === true && match?.notApplicable === true;
    return {
      standardNumber: standard.number,
      meetsStandard:
        !notApplicable &&
        (match?.meetsStandard === true || match?.meetsStandard === false)
          ? match.meetsStandard
          : null,
      notApplicable,
      evidence: match?.evidence || [],
      otherSpecify: match?.otherSpecify || "",
      comment: match?.comment || "",
      selectedFiles: (match?.supportingDocuments || []).map((file: any) => ({
        id: file.id,
        name: file.name,
        url: file.url,
        formattedSize: formatBytes(file.size ? file.size * 1024 : 0),
      })),
    };
  });
};
